import { Button, Form, Input } from 'antd';
import { FC, useEffect, useState } from 'react';

import InputError from './InputError';

interface SetupPasswordProps {
  t: (key: string) => string;
  loading: boolean;
  inputErrorMsg?: string;
  onValuesChange?: (values: { password: string }) => void;
  onSetupSuccess: (values: { password: string }) => Promise<void>;
}

type FieldType = {
  password?: string;
};

export const SetupPassword: FC<SetupPasswordProps> = ({
  t,
  loading,
  inputErrorMsg,
  onValuesChange,
  onSetupSuccess,
}) => {
  return (
    <div className="mt-8 py-1">
      <p className="h4-style py-2">
        {t('merror.login.password.title')}
        <p className="p-style pt-4" style={{ color: '#000' }}>
          {t('merror.login.password.desc')}
        </p>
      </p>

      <div className="flex py-1 mt-5 justify-between items-center">
        <p className="body-style mb-1">{t('merror.login.password.input.title')}</p>
      </div>

      <Form
        initialValues={{ remember: true }}
        onFinish={onSetupSuccess}
        onValuesChange={onValuesChange}
        autoComplete="off"
        className="login-form"
      >
        <Form.Item<FieldType>
          name="password"
          noStyle
          validateStatus={inputErrorMsg ? 'error' : ''}
        >
          <Input.Password
            placeholder={t('merror.login.password.placeholder')}
            className="h-[56px]"
          />
        </Form.Item>

        {inputErrorMsg && <InputError message={inputErrorMsg} />}

        <Form.Item>
          <Button
            loading={loading}
            type="primary"
            htmlType="submit"
            className="w-[100%] mt-8 button-style h-[48px]"
            style={{ height: '48px' }}
          >
            <p className="button-label-style">{t('merror.operate.confirm')}</p>
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
